var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 9.5H16.7V6.7C16.7 4.1 14.6 2 12 2C9.4 2 7.2 4.1 7.2 6.7V9.5H6.7C5.2 9.5 4 10.7 4 12.3V19.3C4 20.8 5.2 22 6.8 22H17.3C18.8 22 20 20.8 20.1 19.2V12.2C20 10.7 18.8 9.5 17.2 9.5ZM8.8 6.7C8.8 4.9 10.3 3.5 12 3.5C13.7 3.5 15.2 5 15.2 6.7V9.5H8.8V6.7ZM18.5 19.3C18.5 20 17.9 20.5 17.3 20.5H6.7C6 20.5 5.5 19.9 5.5 19.3V12.3C5.5 11.6 6.1 11.1 6.7 11.1H17.2C17.9 11.1 18.4 11.7 18.4 12.3L18.5 19.3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleLock);
export default __webpack_public_path__ + "static/media/simple_lock.ada27335c4d3aee674f5057edc8c7221.svg";
export { ForwardRef as ReactComponent };